import { EmailTemplateItemInterface } from 'modules/email/types/email-template-interface'
import { Loader } from 'shared/components/loader'
import { TemplateCard } from 'shared/components/template-card'

export interface EmailTemplateSelectorProps {
  templates?: EmailTemplateItemInterface[]
  templateId?: number
  onChange: (templateId: number) => void
}

const EmailTemplateSelector = ({ onChange, templateId, templates }: EmailTemplateSelectorProps) => {
  return (
    <div className={`overflow-auto`}>
      <ul className={`flex flex-col flex-wrap items-center justify-center gap-5 pb-5 sm:flex-row`}>
        {templates?.map(template => {
          return (
            <TemplateCard
              key={template.id}
              isActive={template.id === templateId}
              onSelect={() => onChange(template.id)}
            >
              <img src={template.previewUrl || ''} className={`absolute h-full object-cover`} />
            </TemplateCard>
          )
        }) || <Loader className="mx-auto" />}
      </ul>
    </div>
  )
}

export default EmailTemplateSelector
